<template>
    <div class="quantity-selection-checkbox" :class="{ visible: isVisible, active: isActive }" ref="selectionElement">
        <div class="quantity-selection-checkbox-circle">
            <i class="fas fa-check" :class="{ circlein: isActive }"></i>
        </div>
        <div class="quantity-selection-checkbox-badge" :class="{ shown: isQuantityBadgeVisible }">
            {{ selectedQuantity }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, ref } from "vue";

    // define properties
    const props = defineProps<{
        selectedQuantity: number;
        totalQuantity: number;
        visible?: boolean;
    }>();

    // define html refs
    const selectionElement = ref<HTMLElement | null>(null);

    // define computed
    const isVisible = computed(() => props.visible ?? true);
    const isActive = computed(() => props.selectedQuantity > 0);
    const isQuantityBadgeVisible = computed(() => isActive.value && props.totalQuantity > 1);
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .quantity-selection-checkbox {
        font-size: 16px;
        position: relative;
        opacity: 0;
        transition: opacity 0.4s variables.$easeOutExpo;

        &.active > .quantity-selection-checkbox-circle {
            background-color: var(--colorPrimary);
            border-color: var(--colorPrimary);
        }

        > .quantity-selection-checkbox-circle {
            height: 1.25em;
            width: 1.25em;
            border: 1px solid colors.$greyBorder;
            border-radius: 50%;
            transition:
                border 0.4s variables.$easeOutExpo,
                background-color 0.4s variables.$easeOutExpo;
            text-align: center;

            > .fas {
                font-size: 0.75em;
                color: colors.$white;
                display: block;
                line-height: 1.666em;
                height: 1.666em;
                transform: rotate(90deg);
                opacity: 0;
                transition:
                    transform 0.8s variables.$easeOutExpo,
                    opacity 0.4s variables.$easeOutExpo;

                &.circlein {
                    transform: rotate(0deg);
                    opacity: 1;
                }
            }
        }

        > .quantity-selection-checkbox-badge {
            font-size: 0.625em;

            position: absolute;
            top: -0.4em;
            left: 1.4em;
            height: 1.5em;
            width: 1.5em;
            border-radius: 50%;
            background-color: colors.$orange;
            color: colors.$white;
            line-height: 1.333em;
            font-weight: 700;
            text-align: center;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.4s variables.$easeOutExpo;
            padding: 0;

            &.shown {
                opacity: 1;
                visibility: visible;
            }
        }

        &.visible {
            opacity: 1;
        }
    }
</style>
